// JavaScript source description
/* eslint-disable */
import React from 'react';
import { BaseFilter, ShowTitleByTitle } from './Scaffolding';
import {
    TextField,
    Show,
    Create,
    BooleanField,
    SimpleForm,
    Edit,
    Datagrid,
    DateField,
    SimpleShowLayout,
    ReferenceField,
    NumberField,
    ReferenceInput,
} from 'react-admin';
import { SwList } from '../lib/SwList';
import { useAzureADGroups } from '../msal/useAzureADGroups';
import { ReadOnlyContext } from '../lib/context/ReadOnlyContext';
import { EditToolbar } from '../layout/EditToolbar';
import {
    AutocompleteInput,
    BooleanInput,
    NumberInput,
    TextInput,
} from '../lib/wrappers/Inputs';

export const JacsCodeLabes = {
    pageTitle: 'JACS Codes',
    Title: 'Code',
    jacs_version: 'JACS version',
    asccode_id: 'ACS Code',
    costcentre_id: 'Cost Centre',
};

export const JacsCodeList = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <SwList
                {...props}
                title={JacsCodeLabes.pageTitle}
                filters={<BaseFilter />}
            >
                <Datagrid
                    rowClick="edit"
                    bulkActionButtons={!canEditStaticData ? false : undefined}
                >
                    <TextField source="id" />
                    <TextField source="description" />
                    <TextField label={JacsCodeLabes.Title} source="Title" />
                    <BooleanField source="current" />
                </Datagrid>
            </SwList>
        </ReadOnlyContext.Provider>
    );
};

export const JacsCodeCreate = (props) => (
    <Create {...props} redirect="edit">
        <JacsCodeInputs {...props} />
    </Create>
);

export const JacsCodeEdit = (props) => (
    <Edit title={<ShowTitleByTitle />} {...props} redirect="edit">
        <JacsCodeInputs {...props} />
    </Edit>
);

export const JacsCodeShow = (props) => (
    <Show title={<ShowTitleByTitle />} {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField label={JacsCodeLabes.Title} source="Title" />
            <TextField source="description" />
            <NumberField
                label={JacsCodeLabes.jacs_version}
                source="jacs_version"
            />
            <ReferenceField
                label={JacsCodeLabes.asccode_id}
                source="asccode_id"
                reference="AscCode"
                allowEmpty
            >
                <TextField source="description" />
            </ReferenceField>
            <ReferenceField
                label={JacsCodeLabes.costcentre_id}
                source="costcentre_id"
                reference="CostCentre"
                allowEmpty
            >
                <TextField source="code" />
            </ReferenceField>
            <BooleanField source="current" />
            <TextField source="created_at" />
            <DateField source="updated_at" />
        </SimpleShowLayout>
    </Show>
);

const JacsCodeInputs = (source) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <SimpleForm toolbar={<EditToolbar />}>
                <div>
                    <TextInput source="id" disabled />
                    <br />
                    <TextInput source="Title" />
                    <br />
                    <TextInput source="description" />
                    <br />
                    <ReferenceInput
                        label={JacsCodeLabes.asccode_id}
                        source="asccode_id"
                        reference="AscCode"
                    >
                        <AutocompleteInput optionText="description" />
                    </ReferenceInput>
                    <br />
                    <ReferenceInput
                        label={JacsCodeLabes.costcentre_id}
                        source="costcentre_id"
                        reference="CostCentre"
                    >
                        <AutocompleteInput optionText="code" />
                    </ReferenceInput>
                    <br />
                    <NumberInput
                        label={JacsCodeLabes.jacs_version}
                        source="jacs_version"
                    />
                    <br />
                    <BooleanInput source="current" />
                    <br />
                    <TextInput source="created_at" disabled />
                    <br />
                    <TextInput source="updated_at" disabled />
                    <br />
                </div>
            </SimpleForm>
        </ReadOnlyContext.Provider>
    );
};
